import { useAppSelector } from 'hooks/reduxHooks'
import { arrayToObject } from 'lib/array/arrayUtils'
import { EmptyObject } from 'lib/object/objectUtils'
import { buildParamsKey } from 'lib/offer/availabilityUtils'
import { useMemo } from 'react'

function useOfferAvailableRates(
  offerId?: string,
  params?: {
    checkIn?: string;
    checkOut?: string;
    rooms?: Array<App.Occupants>;
  },
): App.OfferAvailableRates | undefined {
  const offerAvailableRates = useAppSelector(state => state.offer.offerAvailableRates[offerId || '']) ?? EmptyObject
  const offerAvailableRatesKey = params?.checkIn && params.checkOut && params.rooms ? buildParamsKey(params.checkIn, params.checkOut, params.rooms) : undefined

  return offerAvailableRatesKey ? offerAvailableRates[offerAvailableRatesKey] : undefined
}

export function useOffersAvailableRates(
  offersIds: Array<string>,
  params?: {
    checkIn?: string;
    checkOut?: string;
    rooms?: Array<App.Occupants>;
  },
): { [offerId: string]: App.OfferAvailableRates | undefined } {
  const rates = useAppSelector(state => state.offer.offerAvailableRates)
  const offerAvailableRatesKey = params?.checkIn && params.checkOut && params.rooms ? buildParamsKey(params.checkIn, params.checkOut, params.rooms) : undefined

  const offerRates = useMemo(() => {
    return arrayToObject(offersIds,
      (id) => id,
      id => offerAvailableRatesKey ? rates[id]?.[offerAvailableRatesKey] : undefined,
    )
  }, [offerAvailableRatesKey, offersIds, rates])

  return offerRates ?? EmptyObject
}

export default useOfferAvailableRates
